import { render } from "./Deviations.vue?vue&type=template&id=77f73721"
import script from "./Deviations.vue?vue&type=script&lang=js"
export * from "./Deviations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__